(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cart-quantity-change]');
    if (!button) return;
    const control = button.closest('[data-cart-quantity-control]');
    const form = button.closest('[data-cart-form]');
    const input = control?.querySelector('[data-cart-quantity]');
    const updateButton = form?.querySelector('[data-cart-update]');
    if (!form || !input || !updateButton) return;
    const current = Number.parseInt(input.value, 10) || 0;
    const change = Number.parseInt(button.dataset.cartQuantityChange, 10) || 0;
    const next = Math.max(0, current + change);
    if (next === current) return;
    input.value = String(next);
    const status = form.querySelector('[data-cart-status]');
    if (status) status.textContent = next === 0 ? form.dataset.cartRemoving : form.dataset.cartUpdating;
    form.querySelectorAll('[data-cart-quantity-change]').forEach((item) => { item.disabled = true; });
    form.requestSubmit(updateButton);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-form"]) return;
  try {
    
(() => {
  const container = document.querySelector('[data-quote-form]');
  if (!container) return;
  const form = container.querySelector('form');
  const service = container.querySelector('[data-quote-service]');
  const aliases = {
    'garage-automation': 'smart-garage-controllers',
    'garage-controller': 'smart-garage-controllers',
    'cctv-cameras': 'cctv-systems',
    'smart-blinds-and-curtains': 'smart-blinds-curtains',
    'home-automation': 'full-home-automation'
  };
  const requested = new URLSearchParams(window.location.search).get('service');
  const requestedValue = aliases[requested] || requested;
  if (service && requestedValue && Array.from(service.options).some((option) => option.value === requestedValue)) service.value = requestedValue;
  const attribution = container.querySelector('[data-quote-attribution]');
  if (attribution) {
    const params = new URLSearchParams(window.location.search);
    attribution.value = ['utm_source','utm_medium','utm_campaign','utm_content'].map((name) => {
      const value = params.get(name);
      return value ? name + '=' + value.slice(0,160) : '';
    }).filter(Boolean).join('&');
  }
  const publish = (name, data = {}) => {
    const payload = { page_path: window.location.pathname, ...data };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'automations_smart_' + name, ...payload });
    try {
      const result = window.Shopify?.analytics?.publish?.('automations_smart:' + name, payload);
      result?.catch?.(() => {});
    } catch (_) {}
  };
  let started = false;
  form?.addEventListener('focusin', () => {
    if (started) return;
    started = true;
    publish('quote_started');
  });
  form?.addEventListener('submit', () => {
    if (!form.checkValidity()) return;
    const reference = window.crypto?.randomUUID?.() || String(Date.now());
    const referenceInput = container.querySelector('[data-quote-reference]');
    if (referenceInput) referenceInput.value = reference;
    try { sessionStorage.setItem('automations-smart:pending-quote', JSON.stringify({ reference, createdAt: Date.now() })); } catch (_) {}
    publish('quote_submitted', { quote_reference: reference, service: service?.value || '' });
  });
  const success = container.querySelector('[data-quote-success]');
  if (!success) return;
  success.focus({ preventScroll: true });
  try {
    const pending = JSON.parse(sessionStorage.getItem('automations-smart:pending-quote') || 'null');
    if (!pending || typeof pending.reference !== 'string') return;
    if (!Number.isFinite(pending.createdAt) || Date.now() - pending.createdAt > 1800000 || Date.now() < pending.createdAt) return;
    publish('quote_success', { quote_reference: pending.reference });
    sessionStorage.removeItem('automations-smart:pending-quote');
  } catch (_) {}
})();

  } catch(e) { console.error(e); }
})();
})();
